// SHADOW MARKET™ — Kids Academy i18n (ES / EN / SK)
export const KIDS_UI = {
  es: {
    page_title: "RE₿EL KIDS ACADEMY",
    page_subtitle: "Aprende Bitcoin jugando 🚀",
    age: "Para niños · 8+ años",
    start: "¡Empezar Aventura!",
    level: "Nivel",
    mission: "Misión",
    stars: "estrellas",
    completed: "¡Completado!",
    listen: "🔊 Escuchar",
    mute: "🔇 Silenciar",
    next: "Siguiente →",
    prev: "← Anterior",
    play: "¡A Jugar!",
    points: "puntos",
    record: "¡Nuevo récord!",
    correct: "¡Correcto! 🎉",
    incorrect: "Casi… ¡Inténtalo de nuevo!",
    locked: "¡Completa la misión anterior!",
    map_title: "Mapa de Aventura",
    achievements: "Logros",
    achievements_sub: "Tu colección de trofeos rebeldes",
    no_achievements: "Aún no tienes logros. ¡Completa lecciones para ganarlos!",
    back_to_map: "← Volver al mapa",
    back_to_academy: "← Volver a la Academia",
    lesson_done_title: "¡Misión completada! 🎉",
    lesson_done_sub: "Has ganado estrellas. ¿Listo para el mini-juego?",
    play_game: "¡A Jugar el Mini-Juego!",
    skip_game: "Saltar mini-juego",
    game_score: "¡Conseguiste {n} puntos!",
    game_again: "Jugar otra vez",
    game_continue: "Continuar →",
    badge_earned: "¡Has ganado un trofeo!",
    parents_note: "Para padres: contenido educativo sin compras, sin anuncios, sin recopilación de datos personales.",
  },
  en: {
    page_title: "RE₿EL KIDS ACADEMY",
    page_subtitle: "Learn Bitcoin by playing 🚀",
    age: "For kids · ages 8+",
    start: "Start Adventure!",
    level: "Level",
    mission: "Mission",
    stars: "stars",
    completed: "Completed!",
    listen: "🔊 Listen",
    mute: "🔇 Mute",
    next: "Next →",
    prev: "← Previous",
    play: "Play!",
    points: "points",
    record: "New record!",
    correct: "Correct! 🎉",
    incorrect: "Almost… Try again!",
    locked: "Complete the previous mission!",
    map_title: "Adventure Map",
    achievements: "Achievements",
    achievements_sub: "Your rebel trophy collection",
    no_achievements: "No achievements yet. Complete lessons to earn them!",
    back_to_map: "← Back to map",
    back_to_academy: "← Back to Academy",
    lesson_done_title: "Mission complete! 🎉",
    lesson_done_sub: "You earned stars. Ready for the mini-game?",
    play_game: "Play the Mini-Game!",
    skip_game: "Skip mini-game",
    game_score: "You scored {n} points!",
    game_again: "Play again",
    game_continue: "Continue →",
    badge_earned: "You earned a trophy!",
    parents_note: "For parents: educational content with no purchases, no ads, no personal data collection.",
  },
  sk: {
    page_title: "RE₿EL DETSKÁ AKADÉMIA",
    page_subtitle: "Nauč sa Bitcoin hrou 🚀",
    age: "Pre deti · od 8 rokov",
    start: "Začať Dobrodružstvo!",
    level: "Úroveň",
    mission: "Misia",
    stars: "hviezdy",
    completed: "Dokončené!",
    listen: "🔊 Počúvať",
    mute: "🔇 Stíšiť",
    next: "Ďalej →",
    prev: "← Predchádzajúci",
    play: "Hrať sa!",
    points: "bodov",
    record: "Nový rekord!",
    correct: "Správne! 🎉",
    incorrect: "Skoro… Skús znova!",
    locked: "Dokonči predchádzajúcu misiu!",
    map_title: "Mapa Dobrodružstva",
    achievements: "Úspechy",
    achievements_sub: "Tvoja zbierka rebelských trofejí",
    no_achievements: "Zatiaľ žiadne úspechy. Dokonči lekcie a získaš ich!",
    back_to_map: "← Späť na mapu",
    back_to_academy: "← Späť do Akadémie",
    lesson_done_title: "Misia dokončená! 🎉",
    lesson_done_sub: "Získal si hviezdy. Pripravený na mini-hru?",
    play_game: "Hrať Mini-Hru!",
    skip_game: "Preskočiť mini-hru",
    game_score: "Získal si {n} bodov!",
    game_again: "Hrať znova",
    game_continue: "Pokračovať →",
    badge_earned: "Získal si trofej!",
    parents_note: "Pre rodičov: vzdelávací obsah bez nákupov, bez reklám, bez zbierania osobných údajov.",
  },
  "zh-CN": {
    page_title: "RE₿EL KIDS ACADEMY",
    page_subtitle: "边玩边学比特币 🚀",
    age: "适合儿童 · 8岁以上",
    start: "开始冒险！",
    level: "关卡",
    mission: "任务",
    stars: "星星",
    completed: "已完成！",
    listen: "🔊 收听",
    mute: "🔇 静音",
    next: "下一个 →",
    prev: "← 上一个",
    play: "开始游戏！",
    points: "积分",
    record: "新纪录！",
    correct: "正确！🎉",
    incorrect: "差一点……再试一次！",
    locked: "请先完成上一个任务！",
    map_title: "冒险地图",
    achievements: "成就",
    achievements_sub: "你的反叛者奖杯收藏",
    no_achievements: "你还没有成就。完成课程来获得它们！",
    back_to_map: "← 返回地图",
    back_to_academy: "← 返回学院",
    lesson_done_title: "任务完成！🎉",
    lesson_done_sub: "你获得了星星。准备好玩小游戏了吗？",
    play_game: "开始玩小游戏！",
    skip_game: "跳过小游戏",
    game_score: "你获得了 {n} 积分！",
    game_again: "再玩一次",
    game_continue: "继续 →",
    badge_earned: "你获得了一个奖杯！",
    parents_note: "家长须知：教育内容，无内购，无广告，无个人数据收集。",
  },
  de: {
    page_title: "RE₿EL KIDS ACADEMY",
    page_subtitle: "Bitcoin spielend lernen 🚀",
    age: "Für Kinder · 8+ Jahre",
    start: "Abenteuer starten!",
    level: "Level",
    mission: "Mission",
    stars: "Sterne",
    completed: "Abgeschlossen!",
    listen: "🔊 Anhören",
    mute: "🔇 Stumm",
    next: "Weiter →",
    prev: "← Zurück",
    play: "Los geht's!",
    points: "Punkte",
    record: "Neuer Rekord!",
    correct: "Richtig! 🎉",
    incorrect: "Fast… Versuch's nochmal!",
    locked: "Schließe die vorherige Mission ab!",
    map_title: "Abenteuerkarte",
    achievements: "Erfolge",
    achievements_sub: "Deine Sammlung rebellischer Trophäen",
    no_achievements: "Du hast noch keine Erfolge. Schließe Lektionen ab, um welche zu verdienen!",
    back_to_map: "← Zurück zur Karte",
    back_to_academy: "← Zurück zur Academy",
    lesson_done_title: "Mission abgeschlossen! 🎉",
    lesson_done_sub: "Du hast Sterne verdient. Bereit für das Mini-Spiel?",
    play_game: "Mini-Spiel spielen!",
    skip_game: "Mini-Spiel überspringen",
    game_score: "Du hast {n} Punkte erzielt!",
    game_again: "Nochmal spielen",
    game_continue: "Weiter →",
    badge_earned: "Du hast eine Trophäe verdient!",
    parents_note: "Für Eltern: Bildungsinhalte ohne Käufe, ohne Werbung, ohne Erhebung personenbezogener Daten.",
  },
};

export const getKidsUi = (lang) => KIDS_UI[lang] || KIDS_UI.es;
